import React from 'react';
import { Segment, Menu, Container, Icon, Dropdown } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as routes from '../../shared/routes';
import { useDispatch } from 'react-redux'
import { clearError} from '../signing/ovscSlice'
import { clearError as clearAuthenticodeError } from '../authenticode/authenticodeSlice';
import { useQuery} from '../../shared/useQuery';
import { Media} from './Media'
const DesktopContainer:React.FC<React.PropsWithChildren<{}>> = ( props:any ) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const language = i18n.language.substr(0,2);
  
  const languageString = t("menue.language") + ": " + t("menue." +language);

  const userLanguage = useQuery().get("lang");

  const dm = userLanguage === null ? (
    <Dropdown item text={languageString}>
      <Dropdown.Menu>
        <Dropdown.Item disabled={language==="de"} onClick={()=>{i18n.changeLanguage("de")}}><i className="flag de"></i>{t('menue.de')}</Dropdown.Item>
        <Dropdown.Item disabled={language==="en"} onClick={()=>{i18n.changeLanguage("en")}}><i className="flag us"></i>{t('menue.en')}</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  ) :null;

  return (
    <Media greaterThan='mobile'>
      <Segment
        inverted
        textAlign="center"
        vertical
        style={{ padding: '1em 0em' }}
        color="grey"
        
      >
        
        <Menu inverted pointing secondary size="large">
          <Container>
            <Menu.Item name="home" as={NavLink} to={routes.HOME} onClick={() => dispatch(clearError())} >
              <Icon name="home"  inverted />
              {t('menue.analyze')}
              
            </Menu.Item>
            <Menu.Item name="sign" as={NavLink} to={routes.SIGN} onClick={() => dispatch(clearError())}><Icon name="cog" inverted />{t('menue.sign')}</Menu.Item>
            <Menu.Item name="authenticode" as={NavLink} to={routes.AUTHENTICODE} onClick={() => dispatch(clearAuthenticodeError())}><Icon name="file alternate" inverted />{t('menue.authenticode')}</Menu.Item>
            {dm}
          </Container>
        </Menu>
      </Segment>
      {props.children}
    </Media>
  );
}

export default DesktopContainer;
